import { useEffect } from "react";
import Swal from "sweetalert2";

export function showSuccess(
  message = "Operação realizada com sucesso",
  title = "Sucesso"
) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(Swal.fire(title, message, "success")), 250);
  });
}

export function showError(
  message = "Houve um problema ao realizar esta operação",
  title = "Erro"
) {
  return Swal.fire(title, message, "error");
}

export function showErrorAxios(error: any, fallbackMessage?: string) {
  let message: any = undefined;

  if (!error) {
    return message ?? fallbackMessage;
  }

  if (
    Number(error.response?.status) >= 400 &&
    Number(error.response?.status) <= 499
  ) {
    console.log("message", error.response?.data?.message);

    if (typeof error.response?.data?.message === "string") {
      message = error.response.data.message;
    } else if (
      Array.isArray(error.response?.data?.message) &&
      error.response.data.message.length
    ) {
      message = error.response.data.message[0];
    }
  } else if (Number(error.response?.status) === 500) {
    message = "Está havendo uma inconsistência no sistema no momento.";
  }

  return new Promise((resolve) => {
    setTimeout(() => {
      showError(message ?? fallbackMessage).then(resolve);
    }, 300);
  });
}

export function showConfirm(
  message = "Deseja realmente realizar esta operação?"
) {
  return Swal.fire({
    showCancelButton: true,
    cancelButtonText: "Cancelar",
    title: "Aviso",
    icon: "info",
    text: message,
  });
}

export function showLoading() {
  // Swal.showLoading();
}

export function hideLoading() {
  Swal.close();
}

export function useLoading(bool: boolean) {
  useEffect(() => {
    if (bool) {
      showLoading();
    } else {
      hideLoading();
    }

    return () => hideLoading();
  }, [bool]);
}
